import { rtdbSource } from './internal/RTDBSource';
import { firestoreSource } from './internal/FirestoreSource';

const createFirebaseRepository = () => {

	//Initially undefined. If not found in db, set to null
	let firestoreData = undefined
	let rtdbData = null

	let unsubscribeWebs = null
	let unsubscribeWeb = null
	let unsubscribePageRtdb = null
	let pageCallback = null

	let selectedWeb = null
	let selectedPage = null

	const subscribeToWebs = async setSpaces => {
		if (unsubscribeWebs != null) {
			unsubscribeWebs()
			unsubscribeWebs = null
		}

		unsubscribeWebs = await firestoreSource.subscribeToWebs(webs => {
			webs = webs.map((doc) => {
				let snapshot = doc
				let id = snapshot.ref.parent.parent.path
				id = id.substring(id.indexOf("/") + 1)
				return id
			})
			console.log("web ids", webs)
			setSpaces(webs)
		})
	}

	const subcribeToWeb = async (setWeb, webId) => {
		if (unsubscribeWeb != null) {
			unsubscribeWeb()
			unsubscribeWeb = null
		}

		unsubscribeWeb = await firestoreSource.subscribeToWeb(web => {
			let webData = web.data()
			console.log("web data", webData)
			if(webData == null){
				setWeb({})
			}else{
				setWeb(webData)
			}
		})
	}

	const getWeb = async (web) => {

		if(web == null){
			console.error("Cannot fetch null web")
			return null
		}
		let snapshot;
		try {
			snapshot = await firestoreSource.getWeb(web)
		} catch (e) {
			console.log("Error getting web", e, web)
			return null
		}
		return snapshot.data()
	}

	const setWeb = async (web, data) => {
		return await firestoreSource.setWeb(web, data)
	}

	const getNewWebId = () => {
		return firestoreSource.getNewWebId()
	}

	const createWeb = async (uid, email) => {
		let webId = getNewWebId()

		//TODO remove once migrted to new user format
		await firestoreSource.setPersonUserPage(webId, email, {
			email: email,
			access: ["all"]
		})


		let obj = {}
		obj[[uid]] = { access: ["all"], email: email }
		await firestoreSource.updateUsers(webId, obj)

		return webId
	}

	const updateUsers = async (web, uid, email) => {
		let obj = {}
		obj[[uid]] = { access: ["all"], email: email }
		await firestoreSource.updateUsers(web, obj)
		console.log("updateUsers", web, uid, email)
	}

	const getUsers = async (web) => {
		if(web == null){
			console.error("Cannot fetch users for null web")
			return []
		}
		let snapshot = await firestoreSource.getUsers(web)
		let data = snapshot.data()
		let users = []
		for (let uid in data) {
			users.push({ id: uid, email: data[uid].email, access: data[uid].access })
		}
		return users
	}

	const subscribeToPage = (web, page, handlePage)=>{
		if(selectedWeb === web && selectedPage === page){
			return
		}

		if(unsubscribePageRtdb != null){
			unsubscribePageRtdb()
			unsubscribePageRtdb = null
		}

		firestoreData = undefined
		rtdbData = null
		selectedWeb = web
		selectedPage = page
		
		pageCallback = handlePage

		console.log("subscribeToPage", handlePage)

		//TODO update to subscribe
		getPage(web, page, data => handleFirestorePageSnapshot(data))

		//TODO unable after migrating to tiptap make make merging data easier
		// unsubscribePageRtdb = rtdbSource.subscribeToPage('notes/' + web + "/pages/" + page, snapshot =>{

		// 	let val = snapshot.val()
		// 	console.log(val)
		// 	handleRtdbPageSnapshot(val)

		// })
	}

	const handleFirestorePageSnapshot = (data)=>{
		console.log("handleFirestorePageSnapshot")
		firestoreData = data
		mergeData()
	}

	const handleRtdbPageSnapshot = (data)=>{
		console.log("handleRtdbPageSnapshot")
		rtdbData = data
		mergeData()
	}

	const mergeData = ()=>{
		console.log("Merging", firestoreData, rtdbData)
		if(firestoreData === undefined || rtdbData === undefined){
			return
		}

		let mergedData = {...firestoreData}
		console.log("Merging")
		console.log(mergedData)
		console.log(rtdbData)
		pageCallback(mergedData)
	}

	const getPage = async (web, page, callback) => {
		let docData = await firestoreSource.getPage(web, page)
		console.log("getPage data", docData, docData.data(), web, page)
		callback(docData.data())
	}

	const addPage = async (web, name) => {
		let res = await firestoreSource.addPage(web, {
			name: name
		})
		return res
	}

	const setPage = async (web, page, data) => {
		return await firestoreSource.setPage(web, page, data)
	}

	const updatePage = async (web, page, data) => {
		return await firestoreSource.updatePage(web, page, data)
	}

	const saveChange = async (users, web, page, data) => {
		let dataSet = {}

		for (let user of users) {
			console.log("user", user.id, web, 'notes/' + web + "/users/" + user.id + "/access/all")
			dataSet['notes/' + web + "/users/" + user.id + "/access/all"] = true
		}

		console.log("saveChange", JSON.stringify(dataSet), JSON.stringify(users))

		rtdbSource.updateBulk(dataSet)

		rtdbSource.updateSingle('notes/' + web + "/pages/" + page + "/blocks", data)
	}

	return Object.freeze({
		subscribeToWebs,
		getWeb,
		setWeb,
		createWeb,
		updateUsers,
		getUsers,
		subscribeToPage,
		addPage,
		setPage,
		updatePage,
		saveChange
	})
}

export const firebaseRepository = createFirebaseRepository()